export class ChatModeIcon extends Phaser.GameObjects.Sprite {
    constructor(scene: Phaser.Scene, x: number, y: number) {
        super(scene, x, y, 'layout_modes', 3);
        scene.add.existing(this);
        this.setScrollFactor(0, 0);
        this.setOrigin(0, 1);
        this.setInteractive();
        this.setVisible(false);
        this.setDepth(99999);
    }
}